<script>
import {useStore} from "vuex";
import router from "@/router";
import useClipboard from "vue-clipboard3";
import Swals from "@/assets/js/Swals";

export default {
  name: "AccessPage",
  setup(){

    let store = useStore()

    function set_type_user(id) {
      store.commit('set_user_type' , id)
      router.push({name:'LoginPage'})
    }

    const {toClipboard} = useClipboard()
    async function call_support() {
      let phone_support = store.state.info.phone
      await Swals.Dialog(phone_support, null, 'کپی کردن', 'انصراف').then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(phone_support)
            Swals.Done('شماره پشتیبانی با موفقیت کپی شد');
          } catch (e) {
            Swals.Fault('متاسفانه شماره پشتیبانی کپی نشد!');
          }
        }
      });
    }
    return{
      set_type_user,
      call_support,
    }
  }
}
</script>

<template>
  
  <div class="" id="main">

    <div class="holder-logo rounded-bottom-5 w-100 max_width">
      <div class="position-relative w-100 h-100 d-flex justify-content-center align-items-start">
        <img class="img_logo" src="../assets/img/logoapp.png" alt="">

        <div class="list-access">
          <div @click="set_type_user(1)" class="button item-access d-flex flex-column align-items-center justify-content-center bg-white rounded-4 shadow-custom mb-4 p-3">
            <img class="icon-access mb-3" src="../assets/img/customer.svg" alt="">
            <p class="font-5 text-center">رانندگان و مشتریان و فروشندگان</p>
          </div>

          <div @click="set_type_user(2)" class="item-access d-flex flex-column align-items-center justify-content-center bg-white rounded-4 shadow-custom mb-4 p-3">
            <img class="icon-access mb-3" src="../assets/img/repairman.svg" alt="">
            <p class="font-5">سرویس کار</p>
          </div>

          <div @click="set_type_user(4)" class="item-access d-flex flex-column align-items-center justify-content-center bg-white rounded-4 shadow-custom p-3">
            <img class="icon-access mb-3" src="../assets/img/repairman.svg" alt="">
            <p class="font-5 text-center">تعمیر کار  سرویس کار</p>
          </div>

          <div @click="set_type_user(3)" class="item-access d-flex flex-column align-items-center justify-content-center bg-white rounded-4 shadow-custom p-3">
            <img class="icon-access mb-3" src="../assets/img/repairman.svg" alt="">
            <p class="font-5">تعمیر کار</p>
          </div>
        </div>
      </div>
    </div>


    <div class="position-fixed w-100 max_width d-flex bottom-1">
      <a href="https://sangin-savaran.com/" target="_blank" class="button bg-color-light text-decoration-none p-1 d-flex align-items-center rounded-pill me-2">
        <img style="width: 3rem" class="icon_shadow" src="../assets/img/icon-call-bg-white.svg" alt="">
        <p class="font-5 text-color mx-3">کمک بگیرید</p>
      </a>
    </div>
  </div>

</template>

<style scoped>
.img_logo {
  width: 35%;
  margin-top: 55px;
}
.holder-logo {
  background-image: linear-gradient(to bottom left, #46E2FF, #268EE0, #0335BE);
  position: fixed;
  top: 0;
  height: 45%;
}
.icon-access {
  width: 3rem;
  height: 3rem;
}
.list-access {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  position: absolute;
  bottom: -15rem;
  width: 80%;
}
.item-access {
  flex-grow: 0;
  flex-basis: 45%;
  height: 9rem;
}
</style>